import { it } from 'yup-locales';
import { setLocale } from 'yup';
setLocale(it);

export default () => {};
